<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="50%" append-to-body>
        <div v-loading="loading">
            <Tabs :tabs="detailTbs" :activeCom.sync="Dactive" />
            <div class="detailMsg">
                <BaseList :baseMsg="baseMsg" :detailObj="detailObj" :shiquArray="shiquArray" :isMode.sync="isMode"
                    ref="BaseList" v-bind="$attrs" @modeChanges="modeChanges" @saveDecFn="confrimFn" />
                <Upload :Upload="Upload" :isMode="isMode" ref="upload" />
                <!-- <changeIcon :isMode="isMode" @modeChange="modeChange" /> -->
            </div>
            <Tabs :tabs="tabsArray" :activeCom.sync="TabsActive" @handleTabs="handleTabs" />
            <keep-alive>
                <component :is="TabsActive" :detailNetObj="netObj" v-bind="$attrs" />
            </keep-alive>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('buttonTitle.Close') }}</el-button>
        </div>
    </modal>
</template>

<script>
import Tabs from '@/pages/equipment/publicCom/Tabs.vue';
import Application from '@/pages/equipment/publicCom/Application.vue';
import NetParam from '@/pages/equipment/publicCom/NetParam.vue';
// import changeIcon from '@/pages/equipment/publicCom/changeIcon.vue';
import Upload from '@/pages/equipment/publicCom/Upload.vue';
import BaseList from './component/BaseList.vue';
import bus from '@/utils/bus';
import resultHandle from '@/common/resultHandle';
import { displayUpdate } from '@/api/modules/display.js';

export default {
    props: ['title', 'isDetailShow', 'detailNetObj', 'detailObj', 'shiquArray', 'loading'],
    components: {
        Tabs,
        BaseList,
        Application,
        NetParam,
        Upload
        // changeIcon
    },
    computed: {
        isShowDialog: {
            get: function () {
                return this.isDetailShow;
            },
            set: function (val) {
                this.$emit('update:isDetailShow', val); // 可以优化成model  或者minx
            }
        }
    },
    watch: {
        detailObj(newVal) {
            this.isMode = false;
            this.Upload = {
                imageUrl: { ...newVal }.pictureBase64,
                // 图片后缀
                imageSuffix: { ...newVal }.pictureSuffix
            };
        },
        detailNetObj(newVal) {
            this.netObj.forEach(item => {
                item.content = newVal[item.key];
            });
        }
    },
    data() {
        return {
            isMode: false,
            detailTbs: [
                {
                    name: 'Detail',
                    label: 'public.detail_info'
                }
            ],
            Dactive: 'Detail',
            // 设备tabs
            tabsArray: [
                {
                    name: 'Application',
                    label: 'public.attribute'
                },
                {
                    name: 'NetParam',
                    label: 'public.net_param'
                }
            ],
            TabsActive: 'Application',
            // 图片
            Upload: {},
            baseMsg: [
                {
                    text: 'public.belong',
                    key: 'url'
                },
                {
                    text: 'device.display_name',
                    key: 'name'
                },
                {
                    text: 'public.carrier',
                    key: 'carrierName'
                },
                {
                    text: 'device.display_number',
                    key: 'display_code'
                },
                {
                    key: 'nickname',
                    text: 'device.display_nickname'
                },
                {
                    text: 'device.config_status',
                    key: 'configStatus'
                },
                {
                    text: 'device.display_type',
                    key: 'type'
                },
                {
                    text: 'device.gateway_mac',
                    key: 'ap_mac_addr'
                },
                {
                    text: 'device.time_zone',
                    key: 'time_code'
                },
                {
                    text: 'public.table_create_time',
                    key: 'create_time'
                },
                {
                    text: 'device.stop_time',
                    key: 'stop_time'
                },

                {
                    text: $t('public.table_desc'),
                    key: 'description'
                }
            ],
            appObj: [
                {
                    text: $t('integration.alarm_or_not'),
                    key: 'alarmOn',
                    content: '123'
                },
                {
                    text: $t('integration.duration_(seconds)'),
                    key: 'alarmInterval',
                    content: '123'
                },
                {
                    text: $t('integration.interval_time_(seconds)'),
                    key: 'alarmPeriod',
                    content: '123'
                }
            ],
            netObj: [
                {
                    text: 'ext Pan Id',
                    key: 'extPanId',
                    content: '123'
                },
                {
                    text: 'Join Attemp',
                    key: 'channelPage',
                    content: '123'
                },
                {
                    text: 'device.transmit_power',
                    key: 'transmitPower',
                    content: '123'
                },
                {
                    text: 'device.channel_mask',
                    key: 'channelMask',
                    content: '123'
                },
                {
                    text: 'device.in_net_interval',
                    key: 'inNetInterval',
                    content: '123'
                }
            ],
            description: '',
            isEdit: true
        };
    },
    mounted() {
        if (this.$attrs.sensorWay !== 'bind' && this.$attrs.sensorWay !== 'stop') {
            this.baseMsg.splice(4, 1);
        }
    },
    methods: {
        modeChange() {
            this.isMode = !this.isMode;
        },
        modeChanges(row) {
            this.isMode = !this.isMode;
            this.$parent.detailFn(row);
        },
        handleTabs(name) {
            this.TabsActive = name;
        },
        handleEdit() {
            this.isEdit = !this.isEdit;
        },
        confrimFn(row) {
            const { imageSuffix, imageUrl } = this.$refs.upload.newUpload;
            const { id, nickname, areaValue } = row;

            displayUpdate({
                id,
                nickname,
                description: areaValue,
                uploadFileBase64: imageUrl,
                uploadFileSuffix: imageSuffix
            }).then(async ({ state }) => {
                await resultHandle(state);
                this.isMode = !this.isMode;
                // this.$emit('changdetail', this.detailObj);
                bus.$emit('displayParam', this.detailObj.id, this.detailObj.display_code);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
    min-width: 900px;
}

.detailMsg {
    display: flex;
}

// .detailPage {
//   h1 {
//     font-size: 16px;
//     font-weight: bold;
//     margin-top: 5px;
//     margin-bottom: 10px;
//     padding-bottom: 5px;
//     border-bottom: 1px solid #ccc;
//   }

//   ::v-deep .el-textarea__inner {
//     border-radius: 2px;
//     margin-left: 5px;
//   }

//   li {
//     line-height: 28px;
//     font-size: 14px;
//     color: #606266;
//   }

//   i {
//     cursor: pointer;
//     margin-left: 10px;
//   }
// }
</style>
